import { themeFn } from './theme';
/**
 * ### Prisma's Colors
 * Prisma's base color definitions.
 * All of our colors are accessible by key and are theme aware.
 *   * [Dark Theme](https://www.figma.com/file/AfO3ZrBuuHr8EJ50IU70rL/Prisma-Dark-Theme-(Sandbox))
 *   * [Light Theme](https://www.figma.com/file/pnFbZE8QCFz6GrsTa59kf9/Prisma-Light-Theme-(Sandbox))
 * ---
 * > If you have any questions about color usages please come see us in #prisma on Slack.
 */

export var colors = {
  accents: {
    alert: themeFn(function (props) {
      return props.colors.accents.alert;
    }),
    negative: themeFn(function (props) {
      return props.colors.accents.negative;
    }),
    positive: themeFn(function (props) {
      return props.colors.accents.positive;
    }),
    warning: themeFn(function (props) {
      return props.colors.accents.warning;
    })
  },
  background: {
    dialog: themeFn(function (props) {
      return props.colors.background.dialog;
    }),
    floating: themeFn(function (props) {
      return props.colors.background.floating;
    }),
    navigation: themeFn(function (props) {
      return props.colors.background.navigation;
    }),
    page: themeFn(function (props) {
      return props.colors.background.page;
    }),
    popup: themeFn(function (props) {
      return props.colors.background.popup;
    }),
    section: themeFn(function (props) {
      return props.colors.background.section;
    }),
    sidebar: themeFn(function (props) {
      return props.colors.background.sidebar;
    })
  },
  content: {
    active: themeFn(function (props) {
      return props.colors.content.active;
    }),
    default: themeFn(function (props) {
      return props.colors.content.default;
    }),
    disabled: themeFn(function (props) {
      return props.colors.content.disabled;
    }),
    inverted: themeFn(function (props) {
      return props.colors.content.inverted;
    }),
    muted: themeFn(function (props) {
      return props.colors.content.muted;
    })
  },
  interactive: {
    defaultBackgroundActive: themeFn(function (props) {
      return props.colors.interactive.defaultBackgroundActive;
    }),
    defaultBackground: themeFn(function (props) {
      return props.colors.interactive.defaultBackground;
    }),
    defaultBorder: themeFn(function (props) {
      return props.colors.interactive.defaultBorder;
    }),
    destructiveAction: themeFn(function (props) {
      return props.colors.interactive.destructiveAction;
    }),
    destructiveActionActive: themeFn(function (props) {
      return props.colors.interactive.destructiveActionActive;
    }),
    disabledBackground: themeFn(function (props) {
      return props.colors.interactive.disabledBackground;
    }),
    disabledBorder: themeFn(function (props) {
      return props.colors.interactive.disabledBorder;
    }),
    dragActive: themeFn(function (props) {
      return props.colors.interactive.dragActive;
    }),
    focusedBorder: themeFn(function (props) {
      return props.colors.interactive.focusedBorder;
    }),
    hoverBorder: themeFn(function (props) {
      return props.colors.interactive.hoverBorder;
    }),
    hoverActive: themeFn(function (props) {
      return props.colors.interactive.hoverActive;
    }),
    primaryAction: themeFn(function (props) {
      return props.colors.interactive.primaryAction;
    }),
    primaryActionActive: themeFn(function (props) {
      return props.colors.interactive.primaryActionActive;
    }),
    selectedBackgroundInverted: themeFn(function (props) {
      return props.colors.interactive.selectedBackgroundInverted;
    }),
    selectedActive: themeFn(function (props) {
      return props.colors.interactive.selectedActive;
    })
  },
  neutrals: {
    grey100: themeFn(function (props) {
      return props.colors.neutrals.grey100;
    }),
    grey200: themeFn(function (props) {
      return props.colors.neutrals.grey200;
    }),
    grey300: themeFn(function (props) {
      return props.colors.neutrals.grey300;
    }),
    grey400: themeFn(function (props) {
      return props.colors.neutrals.grey400;
    }),
    grey500: themeFn(function (props) {
      return props.colors.neutrals.grey500;
    }),
    white: themeFn(function (props) {
      return props.colors.neutrals.white;
    })
  },
  scrim: {
    background: themeFn(function (props) {
      return props.colors.scrim.background;
    })
  },
  status: {
    critical: themeFn(function (props) {
      return props.colors.status.critical;
    }),
    high: themeFn(function (props) {
      return props.colors.status.high;
    }),
    info: themeFn(function (props) {
      return props.colors.status.info;
    }),
    low: themeFn(function (props) {
      return props.colors.status.low;
    }),
    medium: themeFn(function (props) {
      return props.colors.status.medium;
    }),
    normal: themeFn(function (props) {
      return props.colors.status.normal;
    })
  },
  syntax: {
    blue: themeFn(function (props) {
      return props.colors.syntax.blue;
    }),
    brown: themeFn(function (props) {
      return props.colors.syntax.brown;
    }),
    green: themeFn(function (props) {
      return props.colors.syntax.green;
    }),
    grey: themeFn(function (props) {
      return props.colors.syntax.grey;
    }),
    orange: themeFn(function (props) {
      return props.colors.syntax.orange;
    }),
    pink: themeFn(function (props) {
      return props.colors.syntax.pink;
    }),
    purple: themeFn(function (props) {
      return props.colors.syntax.purple;
    }),
    red: themeFn(function (props) {
      return props.colors.syntax.red;
    }),
    regular: themeFn(function (props) {
      return props.colors.syntax.regular;
    }),
    teal: themeFn(function (props) {
      return props.colors.syntax.teal;
    })
  }
};
export var colorsByTheme = {
  /**
   * Dark theme color definitions
   */
  dark: {
    accents: {
      alert: '#F6540B',
      negative: '#FF1E59',
      positive: '#00A81A',
      warning: '#C47C00'
    },
    background: {
      dialog: '#1E2024',
      floating: '#FFFFFF',
      navigation: '#08090A',
      page: '#111215',
      popup: '#27292E',
      section: '#1A1C20',
      sidebar: '#0B0C0E'
    },
    content: {
      active: '#FAFAFA',
      default: '#B5B5B5',
      disabled: 'rgba(255, 255, 255, 0.3)',
      inverted: '#000000',
      muted: '#909090'
    },
    interactive: {
      defaultBackgroundActive: 'rgba(0, 0, 0, 0.2)',
      defaultBackground: '#272A2F',
      defaultBorder: 'rgba(255, 255, 255, 0.5)',
      destructiveAction: '#F36464',
      destructiveActionActive: '#CC4A4A',
      disabledBackground: 'rgba(255, 255, 255, 0.15)',
      disabledBorder: 'rgba(255, 255, 255, 0.3)',
      dragActive: 'rgba(57, 147, 255, 0.16)',
      focusedBorder: 'rgba(0, 134, 255, 0.7)',
      hoverBorder: 'rgba(255, 255, 255, 0.7)',
      hoverActive: 'rgba(255, 255, 255, 0.05)',
      primaryAction: '#0086FF',
      primaryActionActive: '#3476CC',
      selectedBackgroundInverted: 'rgba(255, 255, 255, 0.2)',
      selectedActive: 'rgba(255, 255, 255, 0.1)'
    },
    neutrals: {
      grey100: '#393B41',
      grey200: '#44474D',
      grey300: '#52555B',
      grey400: '#5E6167',
      grey500: '#6D6F76',
      white: '#FFFFFF'
    },
    scrim: {
      background: 'rgba(0, 0, 0, 0.8)'
    },
    status: {
      critical: '#751325',
      high: '#F6540B',
      info: '#0089CF',
      low: '#99B100',
      medium: '#DD9900',
      normal: '#85EB48'
    },
    syntax: {
      blue: '#6CD0F0',
      brown: '#FCCF87',
      green: '#CEF06C',
      grey: '#7D7D7D',
      orange: '#F7933F',
      pink: '#F494E5',
      purple: '#A870EF',
      red: '#E85B79',
      regular: '#FFFFFF',
      teal: '#45D4BA'
    }
  },

  /**
   * Light theme color definitions
   */
  light: {
    accents: {
      alert: '#C84015',
      negative: '#D81D47',
      positive: '#118832',
      warning: '#9D6300'
    },
    background: {
      dialog: '#FFFFFF',
      floating: '#000000',
      navigation: '#EDEDED',
      page: '#F9F9F9',
      popup: '#FFFFFF',
      section: '#FFFFFF',
      sidebar: '#F5F5F5'
    },
    content: {
      active: '#2C2C2C',
      default: '#4D4D4D',
      disabled: 'rgba(0, 0, 0, 0.3)',
      inverted: '#FFFFFF',
      muted: '#6B6B6B'
    },
    interactive: {
      defaultBackgroundActive: 'rgba(0, 0, 0, 0.07)',
      defaultBackground: '#EEEEEE',
      defaultBorder: 'rgba(0, 0, 0, 0.4)',
      destructiveAction: '#D41E1F',
      destructiveActionActive: '#C41D1D',
      disabledBackground: 'rgba(0, 0, 0, 0.1)',
      disabledBorder: 'rgba(0, 0, 0, 0.3)',
      dragActive: 'rgba(2, 100, 215, 0.16)',
      focusedBorder: 'rgba(0, 107, 239, 0.7)',
      hoverBorder: 'rgba(0, 0, 0, 0.6)',
      hoverActive: 'rgba(0, 0, 0, 0.03)',
      primaryAction: '#006BEF',
      primaryActionActive: '#2F5DC7',
      selectedBackgroundInverted: '#FFFFFF',
      selectedActive: 'rgba(0, 0, 0, 0.1)'
    },
    neutrals: {
      grey100: '#E7E8EA',
      grey200: '#D8DADE',
      grey300: '#CBCCD0',
      grey400: '#BCBEC4',
      grey500: '#AEB0B6',
      white: '#FFFFFF'
    },
    scrim: {
      background: 'rgba(255, 255, 255, 0.75)'
    },
    status: {
      critical: '#A51A36',
      high: '#FF7D45',
      info: '#00ABFF',
      low: '#99B100',
      medium: '#F4B649',
      normal: '#85EB48'
    },
    syntax: {
      blue: '#107D9F',
      brown: '#A26604',
      green: '#607D0D',
      grey: '#737373',
      orange: '#B75808',
      pink: '#D015B2',
      purple: '#7F52F5',
      red: '#DF1F48',
      regular: '#000000',
      teal: '#1E816F'
    }
  }
};